import { cn } from '../../../utils/tailwind.utils';
import { TextIconColor } from '../constants';
import { Icon, Icons } from '../Icon';
import { ToolTip } from '../ToolTip';
import { Typography, TypographyFont, TypographySize } from '../Typography';

export type DropdownItemProps = {
  onClick: () => void;
  title: string;
  destructive?: boolean | undefined;
  disabled?: boolean;
  icon?: Icon | undefined;
  tooltip?: string | undefined;
};

export const DropdownItem: React.FC<DropdownItemProps> = ({
  icon,
  title,
  onClick,
  destructive = false,
  disabled = false,
  tooltip
}: DropdownItemProps) => {
  const iconAndTextColor = destructive
    ? TextIconColor.DESTRUCTIVE
    : TextIconColor.PRIMARY;

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (disabled) {
      event.stopPropagation();
      return;
    }

    onClick();
  };

  return (
    <ToolTip content={tooltip}>
      {/* 
        role="menuitem" indicates this is a clickable menu item within a menu.
        The parent Dropdown component uses this role to identify clickable items
        and handle closing the dropdown when they are clicked (if closeOnClick is true).
      */}
      <div
        className={cn(
          'flex items-center gap-2 px-2 py-1',
          disabled
            ? 'cursor-not-allowed opacity-50'
            : 'hover:bg-primary-bright-hover cursor-pointer',
          destructive && !disabled && 'hover:[&>*]:text-white'
        )}
        data-testid="dropdown-item"
        onClick={handleClick}
        role="menuitem"
      >
        {icon && <Icons color={iconAndTextColor} icon={icon} />}
        <Typography
          color={iconAndTextColor}
          font={TypographyFont.INTERACTIVE}
          size={TypographySize.SMALL}
        >
          {title}
        </Typography>
      </div>
    </ToolTip>
  );
};

export default DropdownItem;
